// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__HfDgx","copy":"styles_copy__aEtJf","copySuccess":"styles_copySuccess__gChO_","active":"styles_active__Xx8T0"};